import styled, { css } from 'styled-components';
import { color, font, query, space } from '@design/templateFns';

export interface SocialMedia {
  platform: string;
  url: string;
}

export { default as SocialSharing } from './SocialSharing';
export { default as SocialSubscribing } from './SocialSubscribing';

//
// Rendering of individual svg components
export interface SvgProps {
  size: string | '16px';
}

export const renderSVG = (Component: React.FC<SvgProps>, size: string) => {
  return <Component size={size} />;
};

//accept padding props from parent component
export const SvgContainer = styled.div`
  display: block;
  line-height: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;

  a {
    display: inline-block;
    flex: 0 0 auto;
    width: ${space('xl')};
    height: ${space('xl')};
    color: ${color('gray4')};
    transition: color 0.2s ease-in-out;
    &:hover {
      color: ${color('gray5')};
    }

    & + a {
      margin-left: ${space('md')};
    }
  }
`;
